module.exports = "/images/campaign.svg?c0422dc99d5c0479dee804024ce3e533";